//import { Interface } from "readline";
import {Web3} from "web3";
import {ContractAbi} from "web3-types";

export const default_icon = "data:image/svg+xml,%3Csvg%20fill%3D%22none%22%20height%3D%2233%22%20viewBox%3D%220%200%2035%2033%22%20width%3D%2235%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%22.25%22%3E%3Cpath%20d%3D%22m32.9582%201-13.1341%209.7183%202.4424-5.72731z%22%20fill%3D%22%23e17726%22%20stroke%3D%22%23e17726%22%2F%3E%3Cg%20fill%3D%22%23e27625%22%20stroke%3D%22%23e27625%22%3E%3Cpath%20d%3D%22m2.66296%201%2013.01714%209.809-2.3254-5.81802z%22%2F%3E%3Cpath%20d%3D%22m28.2295%2023.5335-3.4947%205.3386%207.4829%202.0603%202.1436-7.2823z%22%2F%3E%3Cpath%20d%3D%22m1.27281%2023.6501%202.13055%207.2823%207.46994-2.0603-3.48166-5.3386z%22%2F%3E%3Cpath%20d%3D%22m10.4706%2014.5149-2.0786%203.1358%207.405.3369-.2469-7.969z%22%2F%3E%3Cpath%20d%3D%22m25.1505%2014.5149-5.1575-4.58704-.1688%208.05974%207.4049-.3369z%22%2F%3E%3Cpath%20d%3D%22m10.8733%2028.8721%204.4819-2.1639-3.8583-3.0062z%22%2F%3E%3Cpath%20d%3D%22m20.2659%2026.7082%204.4689%202.1639-.6105-5.1701z%22%2F%3E%3C%2Fg%3E%3Cpath%20d%3D%22m24.7348%2028.8721-4.469-2.1639.3638%202.9025-.039%201.231z%22%20fill%3D%22%23d5bfb2%22%20stroke%3D%22%23d5bfb2%22%2F%3E%3Cpath%20d%3D%22m10.8732%2028.8721%204.1572%201.9696-.026-1.231.3508-2.9025z%22%20fill%3D%22%23d5bfb2%22%20stroke%3D%22%23d5bfb2%22%2F%3E%3Cpath%20d%3D%22m15.1084%2021.7842-3.7155-1.0884%202.6243-1.2051z%22%20fill%3D%22%23233447%22%20stroke%3D%22%23233447%22%2F%3E%3Cpath%20d%3D%22m20.5126%2021.7842%201.0913-2.2935%202.6372%201.2051z%22%20fill%3D%22%23233447%22%20stroke%3D%22%23233447%22%2F%3E%3Cpath%20d%3D%22m10.8733%2028.8721.6495-5.3386-4.13117.1167z%22%20fill%3D%22%23cc6228%22%20stroke%3D%22%23cc6228%22%2F%3E%3Cpath%20d%3D%22m24.0982%2023.5335.6366%205.3386%203.4946-5.2219z%22%20fill%3D%22%23cc6228%22%20stroke%3D%22%23cc6228%22%2F%3E%3Cpath%20d%3D%22m27.2291%2017.6507-7.405.3369.6885%203.7966%201.0913-2.2935%202.6372%201.2051z%22%20fill%3D%22%23cc6228%22%20stroke%3D%22%23cc6228%22%2F%3E%3Cpath%20d%3D%22m11.3929%2020.6958%202.6242-1.2051%201.0913%202.2935.6885-3.7966-7.40495-.3369z%22%20fill%3D%22%23cc6228%22%20stroke%3D%22%23cc6228%22%2F%3E%3Cpath%20d%3D%22m8.392%2017.6507%203.1049%206.0513-.1039-3.0062z%22%20fill%3D%22%23e27525%22%20stroke%3D%22%23e27525%22%2F%3E%3Cpath%20d%3D%22m24.2412%2020.6958-.1169%203.0062%203.1049-6.0513z%22%20fill%3D%22%23e27525%22%20stroke%3D%22%23e27525%22%2F%3E%3Cpath%20d%3D%22m15.797%2017.9876-.6886%203.7967.8704%204.4833.1949-5.9087z%22%20fill%3D%22%23e27525%22%20stroke%3D%22%23e27525%22%2F%3E%3Cpath%20d%3D%22m19.8242%2017.9876-.3638%202.3584.1819%205.9216.8704-4.4833z%22%20fill%3D%22%23e27525%22%20stroke%3D%22%23e27525%22%2F%3E%3Cpath%20d%3D%22m20.5127%2021.7842-.8704%204.4834.6236.4406%203.8584-3.0062.1169-3.0062z%22%20fill%3D%22%23f5841f%22%20stroke%3D%22%23f5841f%22%2F%3E%3Cpath%20d%3D%22m11.3929%2020.6958.104%203.0062%203.8583%203.0062.6236-.4406-.8704-4.4834z%22%20fill%3D%22%23f5841f%22%20stroke%3D%22%23f5841f%22%2F%3E%3Cpath%20d%3D%22m20.5906%2030.8417.039-1.231-.3378-.2851h-4.9626l-.3248.2851.026%201.231-4.1572-1.9696%201.4551%201.1921%202.9489%202.0344h5.0536l2.962-2.0344%201.442-1.1921z%22%20fill%3D%22%23c0ac9d%22%20stroke%3D%22%23c0ac9d%22%2F%3E%3Cpath%20d%3D%22m20.2659%2026.7082-.6236-.4406h-3.6635l-.6236.4406-.3508%202.9025.3248-.2851h4.9626l.3378.2851z%22%20fill%3D%22%23161616%22%20stroke%3D%22%23161616%22%2F%3E%3Cpath%20d%3D%22m33.5168%2011.3532%201.1043-5.36447-1.6629-4.98873-12.6923%209.3944%204.8846%204.1205%206.8983%202.0085%201.52-1.7752-.6626-.4795%201.0523-.9588-.8054-.622%201.0523-.8034z%22%20fill%3D%22%23763e1a%22%20stroke%3D%22%23763e1a%22%2F%3E%3Cpath%20d%3D%22m1%205.98873%201.11724%205.36447-.71451.5313%201.06527.8034-.80545.622%201.05228.9588-.66255.4795%201.51997%201.7752%206.89835-2.0085%204.8846-4.1205-12.69233-9.3944z%22%20fill%3D%22%23763e1a%22%20stroke%3D%22%23763e1a%22%2F%3E%3Cpath%20d%3D%22m32.0489%2016.5234-6.8983-2.0085%202.0786%203.1358-3.1049%206.0513%204.1052-.0519h6.1318z%22%20fill%3D%22%23f5841f%22%20stroke%3D%22%23f5841f%22%2F%3E%3Cpath%20d%3D%22m10.4705%2014.5149-6.89828%202.0085-2.29944%207.1267h6.11883l4.10519.0519-3.10487-6.0513z%22%20fill%3D%22%23f5841f%22%20stroke%3D%22%23f5841f%22%2F%3E%3Cpath%20d%3D%22m19.8241%2017.9876.4417-7.5932%202.0007-5.4034h-8.9119l2.0006%205.4034.4417%207.5932.1689%202.3842.013%205.8958h3.6635l.013-5.8958z%22%20fill%3D%22%23f5841f%22%20stroke%3D%22%23f5841f%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E";
export const bnb_icon = "data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!-- Generator: Adobe Illustrator 26.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 2496 2496' style='enable-background:new 0 0 2496 2496;' xml:space='preserve'%3E%3Cg%3E%3Cpath style='fill-rule:evenodd;clip-rule:evenodd;fill:%23F0B90B;' d='M1248,0c689.3,0,1248,558.7,1248,1248s-558.7,1248-1248,1248 S0,1937.3,0,1248S558.7,0,1248,0L1248,0z'/%3E%3Cpath style='fill:%23FFFFFF;' d='M685.9,1248l0.9,330l280.4,165v193.2l-444.5-260.7v-524L685.9,1248L685.9,1248z M685.9,918v192.3 l-163.3-96.6V821.4l163.3-96.6l164.1,96.6L685.9,918L685.9,918z M1084.3,821.4l163.3-96.6l164.1,96.6L1247.6,918L1084.3,821.4 L1084.3,821.4z'/%3E%3Cpath style='fill:%23FFFFFF;' d='M803.9,1509.6v-193.2l163.3,96.6v192.3L803.9,1509.6L803.9,1509.6z M1084.3,1812.2l163.3,96.6 l164.1-96.6v192.3l-164.1,96.6l-163.3-96.6V1812.2L1084.3,1812.2z M1645.9,821.4l163.3-96.6l164.1,96.6v192.3l-164.1,96.6V918 L1645.9,821.4L1645.9,821.4L1645.9,821.4z M1809.2,1578l0.9-330l163.3-96.6v524l-444.5,260.7v-193.2L1809.2,1578L1809.2,1578 L1809.2,1578z'/%3E%3Cpolygon style='fill:%23FFFFFF;' points='1692.1,1509.6 1528.8,1605.3 1528.8,1413 1692.1,1316.4 1692.1,1509.6 '/%3E%3Cpath style='fill:%23FFFFFF;' d='M1692.1,986.4l0.9,193.2l-281.2,165v330.8l-163.3,95.7l-163.3-95.7v-330.8l-281.2-165V986.4 L968,889.8l279.5,165.8l281.2-165.8l164.1,96.6H1692.1L1692.1,986.4z M803.9,656.5l443.7-261.6l444.5,261.6l-163.3,96.6 l-281.2-165.8L967.2,753.1L803.9,656.5L803.9,656.5z'/%3E%3C/g%3E%3C/svg%3E%0A";
export const tt_icon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 3500 3500'%3E%3Ctitle%3EAsset 12%3C/title%3E%3Cg id='Layer_2' data-name='Layer 2'%3E%3Cg id='Layer_1-2' data-name='Layer 1'%3E%3Cpath id='SVGID' d='M1750,0c966.5,0,1750,783.5,1750,1750S2716.5,3500,1750,3500,0,2716.5,0,1750,783.5,0,1750,0Z' style='fill:%23ffe81c'/%3E%3Cpolygon id='SVGID-2' data-name='SVGID' points='2887.2 949.3 2681.3 1618.1 2163.7 1618.1 2083.8 1679 1803.3 2839.9 1023.8 2839.9 1169.6 2406.4 1180.6 2364.1 861.7 2606.2 1303.2 1964.5 1407.1 1618.1 701.8 1618.1 905.8 949.3 1789.2 949.3 1857.7 949.3 2219.6 717.5 2072 949.3 2887.2 949.3' style='fill:%233f3f3f'/%3E%3Cpolygon id='SVGID-3' data-name='SVGID' points='2609.4 1518 2755.9 1067.7 2104.3 1067.7 1924.7 1361.5 2334.6 1516.1 2609.4 1518' style='fill:%23ffe81c'/%3E%3Cpolygon id='SVGID-4' data-name='SVGID' points='1185.9 2265.6 2114.2 1562.1 1704.3 1389.7 1729.4 1349 1974.2 965.3 1976.1 961.5 1272.7 1412.2 1640.8 1604.4 1185.9 2265.6' style='fill:%23ffe81c'/%3E%3Cpolygon id='SVGID-5' data-name='SVGID' points='1706.6 2709.4 1914.4 1915.7 1297.1 2396.5 1197 2709 1706.6 2709 1706.6 2709.4' style='fill:%23ffe81c'/%3E%3Cpolygon id='SVGID-6' data-name='SVGID' points='1012 1424.7 1568.8 1069.2 971.7 1067.7 833.5 1515.7 1231.2 1518 1012 1424.7' style='fill:%23ffe81c'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E";
export const hpb_icon = "data:image/svg+xml,%3Csvg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 391.64 378.03' width='2500' height='2413'%3E%3Cdefs%3E%3ClinearGradient id='a' x1='410.93' y1='112.11' x2='133.08' y2='83.21' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='.01' stop-color='%232ae4e8'/%3E%3Cstop offset='.4' stop-color='%2322c4d9'/%3E%3Cstop offset='.56' stop-color='%231eb7d2'/%3E%3Cstop offset='1' stop-color='%230b65c1'/%3E%3C/linearGradient%3E%3ClinearGradient id='c' x1='410.36' y1='110.97' x2='206.42' y2='139.19' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='.01' stop-color='%23a8dae3'/%3E%3Cstop offset='.56' stop-color='%23c4e6ec'/%3E%3Cstop offset='1' stop-color='%23f0f9fa'/%3E%3C/linearGradient%3E%3ClinearGradient id='d' x1='382.53' y1='272.81' x2='181.7' y2='251.92' xlink:href='%23a'/%3E%3ClinearGradient id='b' x1='275.65' y1='321.71' x2='75.7' y2='258.21' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='.01' stop-color='%23a8dae3'/%3E%3Cstop offset='.21' stop-color='%23b2dee6'/%3E%3Cstop offset='.45' stop-color='%23bee3ea'/%3E%3Cstop offset='.56' stop-color='%23c4e6ec'/%3E%3Cstop offset='1' stop-color='%23f0f9fa'/%3E%3C/linearGradient%3E%3ClinearGradient id='e' x1='210.6' y1='252.08' x2='1.28' y2='250.84' xlink:href='%23a'/%3E%3ClinearGradient id='f' x1='230.41' y1='100.9' x2='23.55' y2='116.78' xlink:href='%23b'/%3E%3C/defs%3E%3Ctitle%3Ehpb%3C/title%3E%3Cpath d='M207.22 174.44s26-59-25-116c0 0-29-38-89-35l12-4.8a25.81 25.81 0 0 1 6.21-1.64l11.79-1.57 83-13s29.33-5.87 51.57.6a38.06 38.06 0 0 1 16.68 10.13c12.26 12.68 36.9 46.22 20.75 99.27 0 0-16 59-76 73 0 .01-15 4.01-12-10.99z' fill='url(%23a)'/%3E%3Cpath d='M217.68 192.18s63.91-8.49 86.06-81.7c0 0 17.36-44.54-16.42-94.22L297.66 24a26.42 26.42 0 0 1 4.63 4.46l7.47 9.25 54.29 64.12s20.26 22 26.31 44.36a38.06 38.06 0 0 1 0 19.51c-4.45 17.06-20.28 55.56-74 69.37 0 0-58.71 17-101.88-26.93.05.01-11.17-10.72 3.2-15.96z' fill='url(%23c)'/%3E%3Cpath d='M203.51 207.32S241 259.77 316.05 245c0 0 47.48-5.58 75.48-58.73l-2 12.76a26.09 26.09 0 0 1-1.77 6.19l-4.66 10.94-31.12 78s-9.91 28.22-26.82 44.06a38 38 0 0 1-17.16 9.17c-17.15 4.08-58.57 8.18-96-32.75 0 0-42.6-43.85-24.06-102.6-.01-.04 4.2-14.94 15.57-4.72z' fill='url(%23d)'/%3E%3Cpath d='M185.57 204.25s-27.46 58.33 22.1 116.59c0 0 28 38.71 88.1 37.21l-12.11 4.49a26 26 0 0 1-6.26 1.46l-11.82 1.28-83.3 10.92s-29.46 5.13-51.54-1.89a38.16 38.16 0 0 1-16.42-10.54c-11.94-13-35.73-47.12-18.27-99.75 0 0 17.47-58.59 77.8-71.08 0 .06 15.15-3.61 11.72 11.31z' fill='url(%23b)'/%3E%3Cpath d='M176.36 188.39s-64.1 6.86-88.11 79.48c0 0-18.5 44.08 14 94.61l-10.13-8a25.73 25.73 0 0 1-4.51-4.58l-7.24-9.44L27.74 275S8 252.47 2.57 230A38.07 38.07 0 0 1 3 210.45c4.88-16.95 21.68-55 75.72-67.46 0 0 59.12-15.53 101.16 29.52.04 0 10.98 11.01-3.52 15.88z' fill='url(%23e)'/%3E%3Cpath d='M187.7 173.52s-38.25-51.91-113.06-36c0 0-47.39 6.25-74.64 59.79l1.8-12.81a26.59 26.59 0 0 1 1.68-6.2l4.5-11L38 88.82s9.5-28.36 26.18-44.43A38 38 0 0 1 81.26 35c17.1-4.33 58.45-9 96.44 31.38 0 0 43.22 43.23 25.51 102.24 0-.04-3.99 14.96-15.51 4.9z' fill='url(%23f)'/%3E%3C/svg%3E";

/*
export let chains = {
	"1337": {name:"Geth Testnet", contractAddress: "0x76826125908B4bDb91f57a1b8Ef659ac3AF8c206", symbol: "ETH", icon: default_icon},
	"108": {name: "ThunderCore", contractAddress: "", symbol: "TT", icon: default_icon},
	"56": {name: "Binance Smart Chain", contractAddress: "", symbol: "BNB", icon: default_icon}
}
*/
export let default_launch_time : Date = new Date(Date.UTC(2024, 8-1, 29, 11, 0, 0, 0));

let chainList : ChainInfo[] = [];

export interface ChainInfoNativeCurrency{
	readonly name: string;
	readonly symbol: string;
	readonly decimals: number;
}

export interface ChainInfoExplorer{
	readonly "name": string,
	readonly "url": string,
	readonly "standard": string
	readonly "icon"?: string
}

export interface IChainInfo{
	readonly testnet?: boolean;
	readonly chainId: number;
	readonly name: string;
	readonly chain: string;
	readonly rpc: string[]
	readonly faucets: string[]
	readonly nativeCurrency: ChainInfoNativeCurrency;
	readonly infoURL: string;
	readonly shortName: string;
	readonly networkId: Number;
	readonly slip44: Number;
	readonly explorers?: ChainInfoExplorer[];
	/*readonly*/ icon?: string;
}
export class ChainInfo implements IChainInfo{
	readonly testnet?: boolean;
	readonly chainId: number;
	readonly name: string;
	readonly chain: string;
	readonly rpc: string[]
	readonly faucets: string[]
	readonly nativeCurrency: ChainInfoNativeCurrency;
	readonly infoURL: string;
	readonly shortName: string;
	readonly networkId: Number;
	readonly slip44: Number;
	readonly explorers?: ChainInfoExplorer[];
	/*readonly*/ icon?: string;

	getAddEthereumChainParameter(){
		return getAddEthereumChainParameter(this.chainId);
	}
}

export interface IUdiceValuer{
	coinsToFiat(amount:bigint): {amount:bigint, currencyCode:string, toString: string, format: ()=>string};
	tokensToFiat(amount:bigint): {amount:bigint, currencyCode:string, toString: string, format: ()=>string};
}
export class UdiceValuer implements IUdiceValuer{

	private web3: Web3;
	private currencyCode: string;
	private perCoin: bigint;
	private perToken: bigint;

	constructor(web3: Web3, perCoin: bigint, perToken:bigint, currencyCode: string){
		this.web3 = web3;
		this.currencyCode = currencyCode;
		this.perCoin = perCoin;
		this.perToken = perToken;
	}
	private fromWei(value:bigint){
		return parseFloat(this.web3.utils.fromWei(value, "ether")).toLocaleString(navigator.language, { maximumFractionDigits: 2, minimumFractionDigits: 2});
	}
	coinsToFiat(amount: bigint): { amount: bigint; currencyCode: string, toString: string, format: ()=>string } {
		if(this.perCoin==null){
			return {amount:null, currencyCode: null, toString:null, format: ()=>""};
		}
		let value = (amount*this.perCoin)/BigInt("1000000000000000000");
		let fromWei = this.fromWei(value) +" "+ this.currencyCode;
		return {amount: value, currencyCode: this.currencyCode, toString: fromWei, format: ()=>{
			return fromWei;
		}};
	}
	tokensToFiat(amount: bigint): { amount: bigint; currencyCode: string, toString: string, format: ()=>string } {
		if(this.perToken==null){
			return {amount:null, currencyCode: null, toString:null, format: ()=>""};
		}
		let value = (amount*this.perToken)/BigInt("1000000000000000000");
		let fromWei = this.fromWei(value) +" "+ this.currencyCode;
		return {amount: value, currencyCode: this.currencyCode, toString: fromWei, format: ()=>fromWei};
	}

}

export interface IUdiceContractSupport{
	getValuer(): Promise<IUdiceValuer>;
}

export interface IUdiceContractInfo{
	readonly displayName: string;
	readonly testnet?: boolean;
	readonly contractAddress: string;
	readonly playGas:string;
	readonly contractAbi: ContractAbi;
	readonly created: Date;
	readonly launchTime: Date;
	readonly defaultWager?: string;
	readonly deprecated?: boolean;
	readonly chain: IChainInfo;
	readonly iconUrl: string;
	readonly title?: string;
	readonly support?: (web3: Web3)=>IUdiceContractSupport;
	readonly buyUrl?:string;
	readonly sellUrl?:string;
}

export class UdiceContractInfo implements IUdiceContractInfo{
	readonly displayName: string;
	readonly testnet?: boolean;
	readonly contractAddress: string;
	readonly playGas:string;
	readonly contractAbi: ContractAbi;
	readonly created: Date;
	readonly launchTime: Date;
	readonly defaultWager?: string;
	readonly deprecated?: boolean;
	readonly chain: ChainInfo;
	readonly iconUrl: string;
	readonly title?: string;
	readonly support?: (web3: Web3)=>IUdiceContractSupport;
	readonly buyUrl?:string;
	readonly sellUrl?:string;

	constructor(){
		this.chain = Object.assign(new ChainInfo(), this.chain);
	}
	
	isContractEvent(eventName: string): boolean{
		if(!isContractEventResult.has(eventName)){
			let i = this.contractAbi.find(item=>item['name']!=null && item['name']==eventName);
			isContractEventResult.set(eventName, i!=null);
		}
		return isContractEventResult.get(eventName);
	}

	listEvents() : string[]{
		if(_list_events_result!=null){
			return _list_events_result;
		}
		return _list_events_result = this.contractAbi
			.filter(item=>item.type=='event' && item['name']!=null)
			.map(item=>item['name']);
	}
	
	getAddEthereumChainParameter(){
		return getAddEthereumChainParameter(this.chain.chainId);
	}

}

//https://github.com/ethereum-lists/chains
let CHAINS : ChainInfo[] = [];
//CHAINS.forEach(chain=> registerChain(chain));

export function registerChain(chainInfo: IChainInfo){
	if(chainList[chainInfo.chainId] != null){
		throw new Error("Chain ID already registered: "+chainInfo.chainId);
	}
	chainList[chainInfo.chainId] = Object.assign(new ChainInfo(), chainInfo);
	CHAINS.push(chainList[chainInfo.chainId]);
}

/*
export function findChainById(chainId : number): ChainInfo|null{
	return chainList[chainId];
}

export function getChainList() : ChainInfo[]{
	//return chainList;
	return CHAINS;
}
	*/

//https://eips.ethereum.org/EIPS/eip-3085
export function getAddEthereumChainParameter(chainId : number){
	let contracts = ContractsRegistry.getInstance().allContracts();
	let chain: ChainInfo;
	for(var i=0; i<contracts.length; i++){
		if(contracts[i].chain.chainId==chainId){
			chain = contracts[i].chain;
			break;
		}
	}
	if(chain==null) throw new Error("Unknown chainId "+chainId);
	let explorers = chain.explorers?chain.explorers.map(explorer=>explorer.url):undefined;
	let param = {
		chainId: "0x"+BigInt(chain.chainId).toString(16),
		blockExplorerUrls: explorers,
		chainName: chain.name,
		iconUrls: [chain.icon],
		nativeCurrency: chain.nativeCurrency,
		rpcUrls: chain.rpc,
	}
	return param;
}

var _list_events_result : string[];

var isContractEventResult = new Map<string, boolean>();

/*
export let contractAbi : ContractAbi = [
	{
		"inputs": [],
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"inputs": [],
		"name": "ECDSAInvalidSignature",
		"type": "error"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "length",
				"type": "uint256"
			}
		],
		"name": "ECDSAInvalidSignatureLength",
		"type": "error"
	},
	{
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "s",
				"type": "bytes32"
			}
		],
		"name": "ECDSAInvalidSignatureS",
		"type": "error"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "spender",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "allowance",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "needed",
				"type": "uint256"
			}
		],
		"name": "ERC20InsufficientAllowance",
		"type": "error"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "sender",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "balance",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "needed",
				"type": "uint256"
			}
		],
		"name": "ERC20InsufficientBalance",
		"type": "error"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "approver",
				"type": "address"
			}
		],
		"name": "ERC20InvalidApprover",
		"type": "error"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "receiver",
				"type": "address"
			}
		],
		"name": "ERC20InvalidReceiver",
		"type": "error"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "sender",
				"type": "address"
			}
		],
		"name": "ERC20InvalidSender",
		"type": "error"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "spender",
				"type": "address"
			}
		],
		"name": "ERC20InvalidSpender",
		"type": "error"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "deadline",
				"type": "uint256"
			}
		],
		"name": "ERC2612ExpiredSignature",
		"type": "error"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "signer",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "owner",
				"type": "address"
			}
		],
		"name": "ERC2612InvalidSigner",
		"type": "error"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "balance",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "payment",
				"type": "uint256"
			}
		],
		"name": "InsufficientBalance",
		"type": "error"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "account",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "currentNonce",
				"type": "uint256"
			}
		],
		"name": "InvalidAccountNonce",
		"type": "error"
	},
	{
		"inputs": [],
		"name": "InvalidAddress",
		"type": "error"
	},
	{
		"inputs": [
			{
				"internalType": "uint64",
				"name": "submissionId",
				"type": "uint64"
			},
			{
				"internalType": "address",
				"name": "initiator",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "expectedInitiator",
				"type": "address"
			}
		],
		"name": "InvalidRefundInitiator",
		"type": "error"
	},
	{
		"inputs": [],
		"name": "InvalidShortString",
		"type": "error"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "owner",
				"type": "address"
			}
		],
		"name": "OwnableInvalidOwner",
		"type": "error"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "account",
				"type": "address"
			}
		],
		"name": "OwnableUnauthorizedAccount",
		"type": "error"
	},
	{
		"inputs": [
			{
				"internalType": "uint8",
				"name": "bits",
				"type": "uint8"
			},
			{
				"internalType": "uint256",
				"name": "value",
				"type": "uint256"
			}
		],
		"name": "SafeCastOverflowedUintDowncast",
		"type": "error"
	},
	{
		"inputs": [
			{
				"internalType": "string",
				"name": "str",
				"type": "string"
			}
		],
		"name": "StringTooLong",
		"type": "error"
	},
	{
		"inputs": [
			{
				"internalType": "uint64",
				"name": "submissionId",
				"type": "uint64"
			}
		],
		"name": "SubmissionAlreadyProcessed",
		"type": "error"
	},
	{
		"inputs": [
			{
				"internalType": "uint64",
				"name": "submissionId",
				"type": "uint64"
			}
		],
		"name": "SubmissionBeingProcessed",
		"type": "error"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "owner",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "spender",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "value",
				"type": "uint256"
			}
		],
		"name": "Approval",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "address",
				"name": "owner",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "uint64",
				"name": "submissionsPerEpoch",
				"type": "uint64"
			},
			{
				"indexed": false,
				"internalType": "uint96",
				"name": "maxRewardTokensPerEth",
				"type": "uint96"
			},
			{
				"indexed": false,
				"internalType": "uint96",
				"name": "projectFee",
				"type": "uint96"
			},
			{
				"indexed": false,
				"internalType": "uint96",
				"name": "houseEdgeFixed",
				"type": "uint96"
			},
			{
				"indexed": false,
				"internalType": "uint96",
				"name": "houseEdgeRate",
				"type": "uint96"
			},
			{
				"indexed": false,
				"internalType": "uint32",
				"name": "transferGasLimit",
				"type": "uint32"
			},
			{
				"indexed": false,
				"internalType": "uint8",
				"name": "redemptionEpochForwardOffset",
				"type": "uint8"
			}
		],
		"name": "ConfigurationChanged",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "address",
				"name": "player",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "amount",
				"type": "uint256"
			}
		],
		"name": "CreditClaimed",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "address",
				"name": "player",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "amount",
				"type": "uint256"
			}
		],
		"name": "CreditIssued",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [],
		"name": "EIP712DomainChanged",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "start",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "end",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "used",
				"type": "uint256"
			}
		],
		"name": "GasUsed",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "player",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "uint96",
				"name": "wager",
				"type": "uint96"
			},
			{
				"indexed": false,
				"internalType": "uint96",
				"name": "prepaidProjectFee",
				"type": "uint96"
			},
			{
				"indexed": true,
				"internalType": "uint64",
				"name": "submissionId",
				"type": "uint64"
			},
			{
				"indexed": false,
				"internalType": "uint96",
				"name": "multiplier",
				"type": "uint96"
			},
			{
				"indexed": false,
				"internalType": "uint96",
				"name": "multiplierBoostTokens",
				"type": "uint96"
			},
			{
				"indexed": false,
				"internalType": "uint32",
				"name": "bet",
				"type": "uint32"
			},
			{
				"indexed": true,
				"internalType": "uint32",
				"name": "status",
				"type": "uint32"
			},
			{
				"components": [
					{
						"internalType": "uint32",
						"name": "roll",
						"type": "uint32"
					},
					{
						"internalType": "uint96",
						"name": "payoutCoins",
						"type": "uint96"
					},
					{
						"internalType": "uint96",
						"name": "payoutTokens",
						"type": "uint96"
					},
					{
						"internalType": "uint96",
						"name": "refundCoins",
						"type": "uint96"
					}
				],
				"indexed": false,
				"internalType": "struct IUDICE.SubmissionOutcome",
				"name": "outcome",
				"type": "tuple"
			},
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "rewardPool",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "playerTokenBalance",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "totalTokenSupply",
						"type": "uint256"
					}
				],
				"indexed": false,
				"internalType": "struct IUDICE.SubmissionEventState",
				"name": "state",
				"type": "tuple"
			}
		],
		"name": "Outcome",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "uint64[]",
				"name": "submissionIds",
				"type": "uint64[]"
			},
			{
				"indexed": false,
				"internalType": "uint32[]",
				"name": "submissionStatuses",
				"type": "uint32[]"
			}
		],
		"name": "OwnerRequestedRefunds",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "previousOwner",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "newOwner",
				"type": "address"
			}
		],
		"name": "OwnershipTransferred",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "uint64",
				"name": "submissionId",
				"type": "uint64"
			},
			{
				"indexed": false,
				"internalType": "uint96",
				"name": "projectFee",
				"type": "uint96"
			},
			{
				"indexed": false,
				"internalType": "uint96",
				"name": "prepaidProjectFee",
				"type": "uint96"
			},
			{
				"indexed": false,
				"internalType": "uint96",
				"name": "onTheHouseProjectFee",
				"type": "uint96"
			},
			{
				"indexed": false,
				"internalType": "uint96",
				"name": "tokensInLieuOfOnTheHouseProjectFee",
				"type": "uint96"
			}
		],
		"name": "ProjectFeeCharged",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "address",
				"name": "player",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "burntTokens",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "tokensValue",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "withdrawTax",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "payoutCoins",
				"type": "uint256"
			}
		],
		"name": "Redeemed",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "player",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "uint96",
				"name": "wager",
				"type": "uint96"
			},
			{
				"indexed": false,
				"internalType": "uint96",
				"name": "prepaidProjectFee",
				"type": "uint96"
			},
			{
				"indexed": true,
				"internalType": "uint64",
				"name": "submissionId",
				"type": "uint64"
			},
			{
				"indexed": false,
				"internalType": "uint96",
				"name": "multiplier",
				"type": "uint96"
			},
			{
				"indexed": false,
				"internalType": "uint96",
				"name": "multiplierBoostTokens",
				"type": "uint96"
			},
			{
				"indexed": false,
				"internalType": "uint32",
				"name": "bet",
				"type": "uint32"
			},
			{
				"indexed": false,
				"internalType": "uint32",
				"name": "status",
				"type": "uint32"
			},
			{
				"components": [
					{
						"internalType": "uint96",
						"name": "projectFee",
						"type": "uint96"
					},
					{
						"internalType": "uint96",
						"name": "houseEdgeFixed",
						"type": "uint96"
					},
					{
						"internalType": "uint64",
						"name": "houseEdgeRate",
						"type": "uint64"
					}
				],
				"indexed": false,
				"internalType": "struct IUDICE.SubmissionEventConfig",
				"name": "config",
				"type": "tuple"
			}
		],
		"name": "Submitted",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "from",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "to",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "value",
				"type": "uint256"
			}
		],
		"name": "Transfer",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "address",
				"name": "owner",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "address",
				"name": "to",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "coins",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "tokens",
				"type": "uint256"
			}
		],
		"name": "TreasuryWithdrawn",
		"type": "event"
	},
	{
		"stateMutability": "payable",
		"type": "fallback"
	},
	{
		"inputs": [],
		"name": "DOMAIN_SEPARATOR",
		"outputs": [
			{
				"internalType": "bytes32",
				"name": "",
				"type": "bytes32"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "owner",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "spender",
				"type": "address"
			}
		],
		"name": "allowance",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "spender",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "value",
				"type": "uint256"
			}
		],
		"name": "approve",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "account",
				"type": "address"
			}
		],
		"name": "balanceOf",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "value",
				"type": "uint256"
			}
		],
		"name": "burn",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "account",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "value",
				"type": "uint256"
			}
		],
		"name": "burnFrom",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "claimCredit",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "decimals",
		"outputs": [
			{
				"internalType": "uint8",
				"name": "",
				"type": "uint8"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "eip712Domain",
		"outputs": [
			{
				"internalType": "bytes1",
				"name": "fields",
				"type": "bytes1"
			},
			{
				"internalType": "string",
				"name": "name",
				"type": "string"
			},
			{
				"internalType": "string",
				"name": "version",
				"type": "string"
			},
			{
				"internalType": "uint256",
				"name": "chainId",
				"type": "uint256"
			},
			{
				"internalType": "address",
				"name": "verifyingContract",
				"type": "address"
			},
			{
				"internalType": "bytes32",
				"name": "salt",
				"type": "bytes32"
			},
			{
				"internalType": "uint256[]",
				"name": "extensions",
				"type": "uint256[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "getConfiguration",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "submissionsPerEpoch",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "maxRewardTokensPerEth",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "projectFee",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "houseEdgeFixed",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "houseEdgeRate",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "transferGasLimit",
				"type": "uint256"
			},
			{
				"internalType": "uint8",
				"name": "redemptionEpochForwardOffset",
				"type": "uint8"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "player",
				"type": "address"
			}
		],
		"name": "getPlayerInfo",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "credit",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "submissionsCount",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "getState",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "submissionsCount",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "pendingPool",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "treasuryPool",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "rewardPool",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "creditPool",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "balance",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "treasuryTokens",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "totalSupply",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint64",
				"name": "submissionId",
				"type": "uint64"
			}
		],
		"name": "getSubmission",
		"outputs": [
			{
				"components": [
					{
						"internalType": "uint96",
						"name": "wager",
						"type": "uint96"
					},
					{
						"internalType": "uint96",
						"name": "projectFee",
						"type": "uint96"
					},
					{
						"internalType": "uint64",
						"name": "blockNumber",
						"type": "uint64"
					},
					{
						"internalType": "uint96",
						"name": "prepaidProjectFee",
						"type": "uint96"
					},
					{
						"internalType": "uint96",
						"name": "multiplier",
						"type": "uint96"
					},
					{
						"internalType": "uint64",
						"name": "houseEdgeRate",
						"type": "uint64"
					},
					{
						"internalType": "uint96",
						"name": "multiplierBoostTokens",
						"type": "uint96"
					},
					{
						"internalType": "uint96",
						"name": "houseEdgeFixed",
						"type": "uint96"
					},
					{
						"internalType": "uint64",
						"name": "submissionId",
						"type": "uint64"
					},
					{
						"internalType": "address payable",
						"name": "player",
						"type": "address"
					},
					{
						"internalType": "uint32",
						"name": "bet",
						"type": "uint32"
					},
					{
						"internalType": "uint32",
						"name": "status",
						"type": "uint32"
					},
					{
						"components": [
							{
								"internalType": "uint32",
								"name": "roll",
								"type": "uint32"
							},
							{
								"internalType": "uint96",
								"name": "payoutCoins",
								"type": "uint96"
							},
							{
								"internalType": "uint96",
								"name": "payoutTokens",
								"type": "uint96"
							},
							{
								"internalType": "uint96",
								"name": "refundCoins",
								"type": "uint96"
							}
						],
						"internalType": "struct IUDICE.SubmissionOutcome",
						"name": "outcome",
						"type": "tuple"
					}
				],
				"internalType": "struct IUDICE.Submission",
				"name": "",
				"type": "tuple"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "getUri",
		"outputs": [
			{
				"internalType": "string",
				"name": "uri",
				"type": "string"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "name",
		"outputs": [
			{
				"internalType": "string",
				"name": "",
				"type": "string"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "owner",
				"type": "address"
			}
		],
		"name": "nonces",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "owner",
		"outputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint64[]",
				"name": "submissionIds",
				"type": "uint64[]"
			}
		],
		"name": "ownerRefund",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "owner",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "spender",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "value",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "deadline",
				"type": "uint256"
			},
			{
				"internalType": "uint8",
				"name": "v",
				"type": "uint8"
			},
			{
				"internalType": "bytes32",
				"name": "r",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32",
				"name": "s",
				"type": "bytes32"
			}
		],
		"name": "permit",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint96",
				"name": "multiplier",
				"type": "uint96"
			}
		],
		"name": "play",
		"outputs": [],
		"stateMutability": "payable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint96",
				"name": "multiplier",
				"type": "uint96"
			},
			{
				"internalType": "uint96",
				"name": "prepaidProjectFee",
				"type": "uint96"
			}
		],
		"name": "playWithFee",
		"outputs": [],
		"stateMutability": "payable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint64",
				"name": "offset",
				"type": "uint64"
			},
			{
				"internalType": "uint64",
				"name": "limit",
				"type": "uint64"
			},
			{
				"internalType": "bool",
				"name": "ascend",
				"type": "bool"
			}
		],
		"name": "queryMySubmissions",
		"outputs": [
			{
				"components": [
					{
						"internalType": "uint96",
						"name": "wager",
						"type": "uint96"
					},
					{
						"internalType": "uint96",
						"name": "projectFee",
						"type": "uint96"
					},
					{
						"internalType": "uint64",
						"name": "blockNumber",
						"type": "uint64"
					},
					{
						"internalType": "uint96",
						"name": "prepaidProjectFee",
						"type": "uint96"
					},
					{
						"internalType": "uint96",
						"name": "multiplier",
						"type": "uint96"
					},
					{
						"internalType": "uint64",
						"name": "houseEdgeRate",
						"type": "uint64"
					},
					{
						"internalType": "uint96",
						"name": "multiplierBoostTokens",
						"type": "uint96"
					},
					{
						"internalType": "uint96",
						"name": "houseEdgeFixed",
						"type": "uint96"
					},
					{
						"internalType": "uint64",
						"name": "submissionId",
						"type": "uint64"
					},
					{
						"internalType": "address payable",
						"name": "player",
						"type": "address"
					},
					{
						"internalType": "uint32",
						"name": "bet",
						"type": "uint32"
					},
					{
						"internalType": "uint32",
						"name": "status",
						"type": "uint32"
					},
					{
						"components": [
							{
								"internalType": "uint32",
								"name": "roll",
								"type": "uint32"
							},
							{
								"internalType": "uint96",
								"name": "payoutCoins",
								"type": "uint96"
							},
							{
								"internalType": "uint96",
								"name": "payoutTokens",
								"type": "uint96"
							},
							{
								"internalType": "uint96",
								"name": "refundCoins",
								"type": "uint96"
							}
						],
						"internalType": "struct IUDICE.SubmissionOutcome",
						"name": "outcome",
						"type": "tuple"
					}
				],
				"internalType": "struct IUDICE.Submission[]",
				"name": "items",
				"type": "tuple[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "player",
				"type": "address"
			},
			{
				"internalType": "uint64",
				"name": "offset",
				"type": "uint64"
			},
			{
				"internalType": "uint64",
				"name": "limit",
				"type": "uint64"
			},
			{
				"internalType": "bool",
				"name": "ascend",
				"type": "bool"
			}
		],
		"name": "queryPlayerSubmissions",
		"outputs": [
			{
				"components": [
					{
						"internalType": "uint96",
						"name": "wager",
						"type": "uint96"
					},
					{
						"internalType": "uint96",
						"name": "projectFee",
						"type": "uint96"
					},
					{
						"internalType": "uint64",
						"name": "blockNumber",
						"type": "uint64"
					},
					{
						"internalType": "uint96",
						"name": "prepaidProjectFee",
						"type": "uint96"
					},
					{
						"internalType": "uint96",
						"name": "multiplier",
						"type": "uint96"
					},
					{
						"internalType": "uint64",
						"name": "houseEdgeRate",
						"type": "uint64"
					},
					{
						"internalType": "uint96",
						"name": "multiplierBoostTokens",
						"type": "uint96"
					},
					{
						"internalType": "uint96",
						"name": "houseEdgeFixed",
						"type": "uint96"
					},
					{
						"internalType": "uint64",
						"name": "submissionId",
						"type": "uint64"
					},
					{
						"internalType": "address payable",
						"name": "player",
						"type": "address"
					},
					{
						"internalType": "uint32",
						"name": "bet",
						"type": "uint32"
					},
					{
						"internalType": "uint32",
						"name": "status",
						"type": "uint32"
					},
					{
						"components": [
							{
								"internalType": "uint32",
								"name": "roll",
								"type": "uint32"
							},
							{
								"internalType": "uint96",
								"name": "payoutCoins",
								"type": "uint96"
							},
							{
								"internalType": "uint96",
								"name": "payoutTokens",
								"type": "uint96"
							},
							{
								"internalType": "uint96",
								"name": "refundCoins",
								"type": "uint96"
							}
						],
						"internalType": "struct IUDICE.SubmissionOutcome",
						"name": "outcome",
						"type": "tuple"
					}
				],
				"internalType": "struct IUDICE.Submission[]",
				"name": "items",
				"type": "tuple[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint64",
				"name": "offset",
				"type": "uint64"
			},
			{
				"internalType": "uint64",
				"name": "limit",
				"type": "uint64"
			},
			{
				"internalType": "bool",
				"name": "ascend",
				"type": "bool"
			}
		],
		"name": "querySubmissions",
		"outputs": [
			{
				"components": [
					{
						"internalType": "uint96",
						"name": "wager",
						"type": "uint96"
					},
					{
						"internalType": "uint96",
						"name": "projectFee",
						"type": "uint96"
					},
					{
						"internalType": "uint64",
						"name": "blockNumber",
						"type": "uint64"
					},
					{
						"internalType": "uint96",
						"name": "prepaidProjectFee",
						"type": "uint96"
					},
					{
						"internalType": "uint96",
						"name": "multiplier",
						"type": "uint96"
					},
					{
						"internalType": "uint64",
						"name": "houseEdgeRate",
						"type": "uint64"
					},
					{
						"internalType": "uint96",
						"name": "multiplierBoostTokens",
						"type": "uint96"
					},
					{
						"internalType": "uint96",
						"name": "houseEdgeFixed",
						"type": "uint96"
					},
					{
						"internalType": "uint64",
						"name": "submissionId",
						"type": "uint64"
					},
					{
						"internalType": "address payable",
						"name": "player",
						"type": "address"
					},
					{
						"internalType": "uint32",
						"name": "bet",
						"type": "uint32"
					},
					{
						"internalType": "uint32",
						"name": "status",
						"type": "uint32"
					},
					{
						"components": [
							{
								"internalType": "uint32",
								"name": "roll",
								"type": "uint32"
							},
							{
								"internalType": "uint96",
								"name": "payoutCoins",
								"type": "uint96"
							},
							{
								"internalType": "uint96",
								"name": "payoutTokens",
								"type": "uint96"
							},
							{
								"internalType": "uint96",
								"name": "refundCoins",
								"type": "uint96"
							}
						],
						"internalType": "struct IUDICE.SubmissionOutcome",
						"name": "outcome",
						"type": "tuple"
					}
				],
				"internalType": "struct IUDICE.Submission[]",
				"name": "items",
				"type": "tuple[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "tokens",
				"type": "uint256"
			}
		],
		"name": "redeem",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint64",
				"name": "submissionId",
				"type": "uint64"
			}
		],
		"name": "refund",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "renounceOwnership",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint96",
				"name": "projectFee",
				"type": "uint96"
			},
			{
				"internalType": "uint96",
				"name": "houseEdgeFixed",
				"type": "uint96"
			},
			{
				"internalType": "uint64",
				"name": "houseEdgeRate",
				"type": "uint64"
			},
			{
				"internalType": "uint32",
				"name": "transferGasLimit",
				"type": "uint32"
			},
			{
				"internalType": "uint8",
				"name": "redemptionEpochForwardOffset",
				"type": "uint8"
			}
		],
		"name": "setConfiguration",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "string",
				"name": "uri",
				"type": "string"
			}
		],
		"name": "setUri",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "symbol",
		"outputs": [
			{
				"internalType": "string",
				"name": "",
				"type": "string"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "totalSupply",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "to",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "value",
				"type": "uint256"
			}
		],
		"name": "transfer",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "from",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "to",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "value",
				"type": "uint256"
			}
		],
		"name": "transferFrom",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "newOwner",
				"type": "address"
			}
		],
		"name": "transferOwnership",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "to",
				"type": "address"
			},
			{
				"internalType": "uint96",
				"name": "amount",
				"type": "uint96"
			}
		],
		"name": "withdrawTreasuryCoins",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "to",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "amount",
				"type": "uint256"
			}
		],
		"name": "withdrawTreasuryTokens",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"stateMutability": "payable",
		"type": "receive"
	}
]
*/

export class ContractsRegistry{
	private static INSTANCE: ContractsRegistry = null;

	static getInstance(): ContractsRegistry{
		if(ContractsRegistry.INSTANCE==null){
			ContractsRegistry.INSTANCE = new ContractsRegistry();
		}
		return ContractsRegistry.INSTANCE;
	}
	private _contracts: UdiceContractInfo[] = [];
	private _list: () => UdiceContractInfo[];

	public register(contract: IUdiceContractInfo){
		this._contracts.filter(item=>{
			if(item.contractAddress==contract.contractAddress){
				if(item.chain.chainId==contract.chain.chainId){
					throw new Error("Contract already registered");
				}
			}
		});
		if(contract.chain.icon==null || contract.chain.icon==""){
			//let x: object = contract.chain;
			//x['icon'] = contract.iconUrl;
			contract.chain.icon = contract.iconUrl;
		}
		let value:UdiceContractInfo = new UdiceContractInfo();
		Object.assign(value, contract);
		//value.chain = Object.assign(new ChainInfo(), contract.chain);
		this._contracts.push(value);
	}

	public listByChainId(chainId : number): UdiceContractInfo[]{
		return this._contracts.filter(item=>item.chain.chainId==chainId);
	}

	allContracts(): UdiceContractInfo[]{
		return this._contracts;
	}

	get list(): ()=>UdiceContractInfo[]{
		if(this._list!=null){
			return ()=>this._list().sort((a,b)=>a.created.getTime()-b.created.getTime());
		}
		//return ()=>this._contracts.sort((a,b)=>a.created.getTime()-b.created.getTime());
		return ()=>this.latestPerChain().sort((a,b)=>a.created.getTime()-b.created.getTime());
	}

	set list(f:()=>UdiceContractInfo[]){
		this._list = f;
	}

	public latestPerChain(): UdiceContractInfo[]{
		let x = this._contracts.map(item=>{
			let map: Map<number, UdiceContractInfo[]> = new Map();
			map.set(item.chain.chainId, [item]);
			return map;
		}).reduce((previous, current)=>{
			let map: Map<number, UdiceContractInfo[]> = previous;
			current.forEach((value, key)=>{
				if(!map.has(key)){
					map.set(key, []);
				}
				map.get(key).push(...value);
			});
			return map;
		});
		return Array.from(x.values()).map(item=>{
			item.sort((a, b)=>a.created.getTime()-b.created.getTime());
			return item[item.length-1];
		});
	}
}